import { ThemeColorKeys, ThemeColors } from '@evrekadev/evreka-ui-components'
import React from 'react'
import { Polyline as LeafletPolyline, PolylineProps as $PolylineProps } from 'react-leaflet'

export type PolylineProps = Omit<$PolylineProps, 'color'> & {
  color: ThemeColorKeys
}

export const Polyline: React.FC<PolylineProps> = ({ ...props }) => {
  return <LeafletPolyline {...props} color={ThemeColors[props.color]} stroke={true} />
}

export const Polylines: React.FC<{ polylines: Array<PolylineProps> }> = ({ polylines }) => {
  return polylines.map((polyline, i) => (
    <Polyline key={`${polyline.color} ${i} ${polyline.positions?.[0]}`} {...polyline} />
  ))
}
